import { USER_FRAGMENT } from '../fragments/user.fragments';

export const THREAD_MEMBERS_BY_ROLE = `
    ${USER_FRAGMENT}

    query ThreadMembersByRole(
        $threadId: ID!
        $roles: [TeamMemberRole!]!
        $nextLink: String
        $state: String
        $pageSize: Int
    ) {
        threadMembersByRole(
            threadId: $threadId
            roles: $roles
            nextLink: $nextLink
            state: $state
            pageSize: $pageSize
        ) {
            members {
                user {
                    ...UserFragment
                }
            }
            nextLink
            totalCount
        }
    }
`;